import { Link } from 'react-router-dom';
import type { Show } from '@/mocks/shows';

interface ShowCardProps {
  show: Show;
  size?: 'small' | 'medium' | 'large';
}

export default function ShowCard({ show, size = 'medium' }: ShowCardProps) {
  const ratingColor = show.rating >= 9.0 ? 'bg-primary-500' : show.rating >= 8.5 ? 'bg-accent-500' : 'bg-secondary-500';

  return (
    <Link
      to={`/article/${show.id}`}
      className="group block overflow-hidden rounded-lg bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300"
    >
      <div className="relative overflow-hidden aspect-[5/7]">
        <img
          src={show.imageUrl}
          alt={`${show.title} - ${show.englishTitle}`}
          title={`${show.title} ${show.englishTitle} 美剧在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className={`${ratingColor} text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap`}>
            {show.rating}
          </span>
        </div>
        {show.status === '连载中' && (
          <div className="absolute top-3 right-3">
            <span className="bg-accent-500 text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
              {show.status}
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {show.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1 truncate">{show.englishTitle}</p>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-xs text-foreground-500">{show.year}</span>
          <span className="text-foreground-300">·</span>
          <span className="text-xs text-foreground-500">{show.seasons}季</span>
          <span className="text-foreground-300">·</span>
          <span className="text-xs text-secondary-600">{show.category}</span>
        </div>
      </div>
    </Link>
  );
}